import React, { FC } from 'react'
import { useIntl } from 'react-intl'
import { useAppContext } from '../contexts/App.context'
import { ShareButton } from '../ui/ShareButton'
import { generateBoxDeepLinkUrl } from '../utils/shareUtils'

export const BoxShareButton: FC<{
  boxId: number
  className?: string
  disabled?: boolean
  onSuccess?: () => void
  onError?: (error: Error) => void
}> = ({ boxId, className, disabled, onSuccess, onError }) => {
  const { referralKey } = useAppContext()
  const { formatMessage } = useIntl()

  const url = generateBoxDeepLinkUrl(boxId, referralKey ?? null)

  return (
    <ShareButton
      url={url}
      text={formatMessage({
        id: 'box.share.text',
        defaultMessage: 'Посмотри на VoteBox!',
      })}
      className={className}
      disabled={disabled}
      onSuccess={onSuccess}
      onError={onError}
    />
  )
}
